import {Component, OnInit} from '@angular/core';
import {DatePickerModule} from '../../../../../shared-components/date-picker/date-picker.module';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {GrPagination} from '../../../../../interfaces/general-interfaces';
import {ReservationsHttpService} from '../../../../../services/http-services/reservations/reservations-http.service';
import {PaginationModule} from '../../../../../shared-components/pagination/pagination.module';

@Component({
  selector: 'gr-for-deliveries-tab',
  standalone: true,
  templateUrl: './for-deliveries-tab.component.html',
  imports: [
    DatePickerModule,
    NgForOf,
    DatePipe,
    NgIf,
    PaginationModule,
  ],
  providers: [DatePipe]
})
export class ForDeliveriesTabComponent implements OnInit {
  orders: any = [];
  ordersPagination: GrPagination | undefined;
  urlParams: {page: number, date: string | null} = {page: 1, date: null};
  currentDate: Date = new Date();
  minDate = new Date(this.currentDate.getFullYear() - 10, this.currentDate.getMonth(), this.currentDate.getDate());
  constructor(private reservationsHttpService: ReservationsHttpService,
              private datePipe: DatePipe) {
  }

  ngOnInit(): void  {
    this.urlParams.date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.getOrders();
  }
  getOrders(): void {
    this.urlParams.page = (this.ordersPagination?.currentPage) ? this.ordersPagination.currentPage : 1;
    this.reservationsHttpService.getOrders(this.urlParams).then((res: any) => {
      this.orders = res.data;
      this.ordersPagination = res.pagination;
    });
  }

  onPageChanged(page: any): void {
    if (this.ordersPagination) {
      this.ordersPagination.currentPage = page;
      this.getOrders();
    }
  }
  exportOrdersExcel(): void {
    this.reservationsHttpService.getExportOrdersExcel(this.urlParams).subscribe((response: Blob) => {
      if (response.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const blobUrl = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'Porudžbine.xlsx';
        link.click();
        URL.revokeObjectURL(blobUrl);
      } else {
        console.error('The fetched file is not an Excel file');
      }
    });
  }
  onSelectedDate(selectedDate: any): void {
    this.urlParams.date = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.getOrders();
  }
}
